import { render } from "./AddComputeOffering.vue?vue&type=template&id=e06f7d16&scoped=true"
import script from "./AddComputeOffering.vue?vue&type=script&lang=js"
export * from "./AddComputeOffering.vue?vue&type=script&lang=js"

import "./AddComputeOffering.vue?vue&type=style&index=0&id=e06f7d16&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e06f7d16"]])

export default __exports__